// @flow

import React from 'react';
import {makeStyles} from '@material-ui/core';
import {colors} from '../../../../assets/styles/colors';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import {useFormContext} from 'react-hook-form';
import {FIELDS_BY_TAB_NAME} from '../../constants';
import {getIsTabWithErrors} from '../../utils/errors';

import {InfoOutlined} from '@material-ui/icons';
import Badge from '@material-ui/core/Badge';
import {useLocation} from 'react-router-dom';

const useStyles = makeStyles(theme => ({
  tabButton: {
    borderRadius: '8px',
    color: colors.grey900,
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'none',
    width: 'fit-content',
    [theme.breakpoints.down('md')]: {
      width: '100%',
      flexBasis: '100%',
    },
  },
  active: {
    backgroundColor: '#FFFFFF',
    color: '#7B39FF',
  },
  wrap: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  errorIcon: {
    color: '#E13065',
  },
  blinkingBadge: {
    '& .MuiBadge-badge': {
      animation: 'blink 1s infinite',
      width: '10px',
      height: '10px',
      top: '.75rem',
    },
  },
  '@global': {
    '@keyframes blink': {
      '0%': {opacity: 1},
      '50%': {opacity: 0.5},
      '100%': {opacity: 1},
    },
  },
}));

type Props = {
  tab: {name: string, key: string},
  active: boolean,
  idx: number,
  onTabSelected: (v: number) => void,
};

const HeaderTab = ({tab, onTabSelected, active, idx}: Props) => {
  const classes = useStyles();
  const {errors} = useFormContext();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const defaultSections = searchParams.get('defaultSection');
  const isHighlighted = defaultSections === tab.key;

  const tabFields = FIELDS_BY_TAB_NAME[tab.key] ?? [];
  const tabErrors = getIsTabWithErrors(
    tabFields.map(el => ({
      field: el.field,
      withoutExactMatch: el.withoutExactMatch,
    })),
    Object.keys(errors)
  );

  return (
    <div className={classes.wrap}>
      {isHighlighted ? (
        <Badge variant="dot" color="primary" className={classes.blinkingBadge}>
          <CustomButton
            className={`${classes.tabButton} ${active ? classes.active : ''}`}
            onClick={() => onTabSelected(idx)}
          >
            {tab.name}
          </CustomButton>
        </Badge>
      ) : (
        <CustomButton
          className={`${classes.tabButton} ${active ? classes.active : ''}`}
          onClick={() => onTabSelected(idx)}
        >
          {tab.name}
        </CustomButton>
      )}

      {tabErrors && (
        <div className={classes.errorIcon}>
          <InfoOutlined />
        </div>
      )}
    </div>
  );
};

export default HeaderTab;
